








import Dialog from '@/components/Dialog.vue'

import Vue, { PropType } from 'vue'
import { Client } from '@/api/Agency/agency.interface'
import ClientCardVue from './ClientCard.vue'
export default Vue.extend({
  props: {
    client: Object as PropType<Client>,
  },
  components: {
    appDialog: Dialog,
    appClientCard: ClientCardVue,
  },
})
